import { Bar, BarChart, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useRef } from 'react';
import { toPng } from 'html-to-image';
import { saveAs } from 'file-saver';
import { Button } from "react-bootstrap";

export const GraficBarChar = ({ data, label }) => {
  const chartRef = useRef(null); // ссылка на DOM-элемент

  const renderCustomizedLabel = (props) => {
    const { x, y, width, height, value } = props;
    return (
      <g>
        <text
          x={x + width + 5}
          y={y + height / 2}
          fill="#666"
          textAnchor="start"
          dominantBaseline="middle"
          fontSize={20}
        >
          {value}
        </text>
      </g>
    );
  };

  // Функция для скачивания PNG
  const handleDownload = async () => {
    if (!chartRef.current) return;
    try {
      // Преобразуем DOM-узел в PNG (в формате data URL)
      const dataUrl = await toPng(chartRef.current, {
        // Опционально: улучшаем качество и убираем фон
        backgroundColor: '#ffffff',
        pixelRatio: 2,
      });
      // Сохраняем файл с помощью file-saver
      saveAs(dataUrl, `график.png`);
    } catch (error) {
      console.error('Ошибка при захвате изображения:', error);
    }
  };

  return (
    <>
      {/* Кнопка для скачивания */}
      <div className="d-flex justify-content-end flex-wrap">
        <Button onClick={handleDownload} className="mb-1 custom-btn">
            Скачать PNG
        </Button>
      </div>

      {/* Контейнер с ref, который будет захвачен */}
      <div
        ref={chartRef}
        style={{ width: '100%', height: 600, backgroundColor: '#ffffff' }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart layout="vertical" data={data}>
            <XAxis type="number" domain={[0, 5]} />
            <YAxis type="category" dataKey="name" width={150} />
            <Tooltip />
            <Legend />
            <Bar dataKey="value" name={label} fill="#1c3572">
              <LabelList dataKey="value" content={renderCustomizedLabel} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};